import { getPageInfo } from "@/utils/helper"
import { FRAGMENT_TYPES, ORDER_STATUS_PAGE } from "@/constants/index"

const getInternalLinkURLS = url => {
  return url?.startsWith("/") || url?.includes(window.location.hostname)
    ? "true"
    : "false"
}

const setLinkAnalytics = (
  linkUrl,
  type,
  getAnalyticsData,
  eventType = "navigation"
) => {
  if (!getAnalyticsData) return null

  const {
    pageTitle = "n/a",
    internalLinkPosition = "n/a",
    addNoFooterInAttr = false,
  } = getAnalyticsData
  if (typeof type !== "string") {
    // this is html content
    const div = document.createElement("div")
    div.innerHTML = type
    // This contains HTML code so remove some bugs here.
    type = (div.innerText || div.textContent || "")?.toLowerCase()
    type = type.replaceAll("\n", "")
  } else {
    type = type.toLowerCase()
  }

  const isOrderStatusPage = pageTitle?.includes(ORDER_STATUS_PAGE)
  const form = !addNoFooterInAttr ? ":form" : ""
  const formFooter = !addNoFooterInAttr ? `:form:${FRAGMENT_TYPES.FOOTER}` : ""
  const eventDetail = isOrderStatusPage
    ? `${pageTitle}:${type}`
    : `${pageTitle}${formFooter}:${type}`
  const eventLinkType = isOrderStatusPage
    ? `my account:${type}`
    : `${pageTitle}${form}:${type}`
  const prefix =
    linkUrl && linkUrl.indexOf("http") === -1 ? window.location.origin : ""
  const eventInfo = {
    clickInternalLinks: getInternalLinkURLS(linkUrl),
    eventAction: eventDetail || "n/a",
    eventName: eventDetail || "n/a",
    eventType,
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: type || "n/a",
    internalLinkPosition: internalLinkPosition || "n/a",
    internalLinkType: eventLinkType,
    internalLinkURL: linkUrl ? prefix + linkUrl : "n/a",
    internalLinkZoneName: `${pageTitle}${formFooter}`,
  }
  addAnalyticsForRecaptchLinks(eventInfo, "cmp:click")
}

const addAnalyticsForRecaptchLinks = (eventInfo, event = "cmp:click") => {
  const page = getPageInfo()

  window.adobeDataLayer.push({
    event,
    eventInfo,
    page,
  })
}

export { setLinkAnalytics, addAnalyticsForRecaptchLinks }
